export * from './feature-detail-tool.component';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/tool/tools/feature-detail-tool/index.ts